<template>
  <div class="page-content-wrapper">
    <div v-if="!getRecipeDetails || getRecipeDetails === {}">
      <loading></loading>
    </div>
    <div v-else
         class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row p-3">
          <b-card :title="getRecipeDetails.Title"
                  tag="article"
                  style="max-width: 30rem"
                  class="mb-2">
            <h6 class="card-text">
              <FormattedCmsText :content="getRecipeDetails"/>
            </h6>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { mapActions } from 'vuex'
    import Loading from '../utilities/Loading.vue'
    import FormattedCmsText from '../utilities/FormattedCmsText'

    export default {
      props: ['recipe_id'],
      components: {
        Loading,
        FormattedCmsText
      },
      computed: {
        ...mapGetters([
          'getRecipeDetails',
        ]),
      },
      methods: {
        ...mapActions([
          'loadRecipeDetails',
        ]),
      },
      created() {
        this.loadRecipeDetails(this.recipe_id)
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/recipes/RecipesPage.vue